module.exports = __webpack_public_path__ + "media/images/el_guirigay-b166544bdce86a8e7786931e575689ef.png";